// src/_redux/reducers/CaseStudySlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    caseStudies: [],
    caseStudy: null, // To store a single case study
    firstAndLast: {
        first: null,
        last: null,
    },
    loading: false,
    error: null,
};

const caseStudySlice = createSlice({
    name: 'caseStudies',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        fetchCaseStudiesSuccess: (state, action) => {
            state.caseStudies = action.payload;
            state.loading = false;
        },
        fetchCaseStudySuccess: (state, action) => {
            state.caseStudy = action.payload;
            state.loading = false;
        },
        fetchCaseStudyIdAltRangeSuccess: (state, action) => {
            state.firstAndLast = action.payload; 
        },
        fetchCaseStudiesFailure: (state, action) => {
            state.error = action.payload;
        },
        clearCaseStudy: (state) => {
            state.caseStudy = null;
        },
        fetchCaseStudyFailure: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

export const {
    setLoading,
    clearCaseStudy,
    fetchCaseStudiesSuccess,
    fetchCaseStudySuccess,
    fetchCaseStudiesFailure,
    fetchCaseStudyFailure,
    fetchCaseStudyIdAltRangeSuccess,
} = caseStudySlice.actions;

export default caseStudySlice.reducer;
